const INITIAL_STATE = []

export default INITIAL_STATE
